// data declaration
import PreRegistration from "@/services/PreRegistration";
import authService from "@/services/auth";
import store from "@/state/store";
import router from "../../router/index";
import moment from "moment";
import { getCustomFieldsPayload}  from "@/utils/mixins/customFieldValueParser";

export const state = {
  area: null,
  user: null,
  compliance: {
    is_image_required: null,
    is_qr_included: null,
    is_face_id_included: null,
    is_rfid_included: null,
    is_compliance_required: null,
  },
  selectedUserType: null,
  visitDate: null,
  visitTime: null,
  expectedDateTime: null,
  firstName: null,
  lastName: null,
  companyName: null,
  email: null,
  userCountryCode: null,
  phoneInput: null,
  entity: null,
  phone: null,
  image: null,
  registrationCheck: null,
  registerPassportAcc: null,
  isLoading: null,
  localQrCodeUrl: null,
  hasFilledForm: null,
  userEntity: null,
  differentUserType: null,
  isSubmitted: null,
  userTypeName: null,
  notAllowedToRegister: null,
  visitExists: null,
  msgTitle: "",
  msgBody: "",
  hasVisitedPage: null,
  isSwitch: null,
  fromLogin: null,
  qrUrl: null,
  redirectLoader: null,
  daysDiff: null,
  offset: null,
  visitApproved: null,
  visitRejected: null,
  approveVisit: null,
  rejectVisit: null,
  apiErr: null,
  refreshGrid: null,
  selectedHost: null,
  expiryMsg: "",
  sectionsData: []
};
// set dsata in local storage
export const mutations = {
  resetState(state) {
    state.compliance = {
      is_image_required: null,
      is_qr_included: null,
      is_face_id_included: null,
      is_rfid_included: null,
      is_compliance_required: null,
    };
    state.entity = null;
    state.area = null;
    state.user = null;
    state.selectedUserType = null;
    state.visitDate = null;
    state.visitTime = null;
    state.firstName = null;
    state.lastName = null;
    state.companyName = null;
    state.email = null;
    state.phone = null;
    state.image = null;
    state.registrationCheck = null;
  },
  setSelecteEntity(state, payload) {
    state.entity = payload;
  },
  setSelectedArea(state, payload) {
    state.area = payload;
  },
  setSelectedEntity(state, payload) {
    state.entity = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },

  setImage(state, payload) {
    state.image = payload;
  },
  setCompliances(state, payload) {
    state.compliance = payload;
  },
  setSelectedUserType(state, payload) {
    state.selectedUserType = payload;
  },
  setVisitDate(state, payload) {
    state.visitDate = payload;
  },
  setVisitTime(state, payload) {
    state.visitTime = payload;
  },
  setExpectedDateTime(state, payload) {
    state.expectedDateTime = payload;
  },
  setFirstName(state, payload) {
    state.firstName = payload;
  },
  setLastName(state, payload) {
    state.lastName = payload;
  },
  setCompanyName(state, payload) {
    state.companyName = payload;
  },
  setEmail(state, payload) {
    state.email = payload;
  },
  setPhone(state, payload) {
    state.phone = payload;
  },
  setPhoneInput(state, payload) {
    state.phoneInput = payload;
  },
  setUserCountryCode(state, payload) {
    state.userCountryCode = payload;
  },
  setRegistrationCheck(state, payload) {
    state.registrationCheck = payload;
  },

  setRegisterPassportAcc(state, payload) {
    state.registerPassportAcc = payload;
  },

  setIsLoading(state, payload) {
    state.isLoading = payload;
  },

  setLocalQrCodeUrl(state, payload) {
    state.localQrCodeUrl = payload;
  },

  setHasFilledForm(state, payload) {
    state.hasFilledForm = payload;
  },

  setUserEntity(state, payload) {
    state.userEntity = payload;
  },

  setDifferentUserType(state, payload) {
    state.differentUserType = payload;
  },

  setSubmitted(state, payload) {
    state.isSubmitted = payload;
  },

  setUserTypeName(state, payload) {
    state.userTypeName = payload;
  },

  setNotAllowedToRegister(state, payload) {
    state.notAllowedToRegister = payload;
  },

  setVisitExists(state, payload) {
    state.visitExists = payload;
  },

  setMsgTitle(state, payload) {
    state.msgTitle = payload;
  },

  setMsgBody(state, payload) {
    state.msgBody = payload;
  },

  setHasVisitedPage(state, payload) {
    state.hasVisitedPage = payload;
  },

  setSwitch(state, payload) {
    state.isSwitch = payload;
  },

  setFromLogin(state, payload) {
    state.fromLogin = payload;
  },

  setQrUrl(state, payload) {
    state.qrUrl = payload;
  },

  setRedirectLoader(state, payload) {
    state.redirectLoader = payload;
  },

  setDaysDiff(state, payload) {
    state.daysDiff = payload;
  },

  setOffset(state, payload) {
    state.offset = payload;
  },

  setVisitApproved(state, payload) {
    state.visitApproved = payload;
  },

  setVisitRejected(state, payload) {
    state.visitRejected = payload;
  },

  setApproveVisit(state, payload) {
    state.approveVisit = payload;
  },

  setRejectVisit(state, payload) {
    state.rejectVisit = payload;
  },

  setApiErr(state, payload) {
    state.apiErr = payload;
  },

  setRefreshGrid(state, payload) {
    state.refreshGrid = payload;
  },

  setSelectedHost(state, payload) {
    state.selectedHost = payload;
  },

  setExpiryMsg(state, payload) {
    state.expiryMsg = payload;
  },
  setSections(state,payload){
    state.sectionsData = payload
  }
};
export const actions = {
  setSections({commit},sectionsData){
    commit("setSections",sectionsData)
  },
  clearSections({commit}){
    commit("setSections",[])
  },
  setSelectedEntity({ commit }, entity) {
    commit("setSelectedEntity", entity);
  },
  setSelectedArea({ commit }, area) {
    commit("setSelectedArea", area);
  },
  setRegisterPassportAcc({ commit }, payload) {
    commit("setRegisterPassportAcc", payload);
  },
  setIsLoading({ commit }, payload) {
    commit("setIsLoading", payload);
  },
  selectDaysDiff({ commit }, payload) {
    commit("setDaysDiff", payload);
  },
  selectOffset({ commit }, payload) {
    commit("setOffset", payload);
  },
  setApiErr({ commit }, payload) {
    commit("setApiErr", payload);
  },

  // register user
  preRegRegisterUserService({ commit }, user) {
    return new Promise((resolve, reject) => {
      authService
        .registerUser(user)
        .then((data) => {
          resolve(data);
          console.log('registerUser', data);
          commit("setUser", data.data.data);
        })
        .catch((err) => {
          reject(err);
          // console.log('errrr', err, Object.values(err.data.errors));
          const errMsg = Object.values(err.data.errors).map(x => Object.values(x).join("\r\n")).join('\r\n');
          this._vm.$toast.error(errMsg);
        });
    });
  },
  setImage({ commit }, params) {
    commit("setImage", params);
  },
  setPassportUser({ commit }, payload) {
    commit("setUser", payload);
  },
  getJourneyFlowCompliance({ commit }, params) {
    PreRegistration.sendJourneyFlowId(params).then(({ data }) => {
      if (data.status === "success") {
        commit("setCompliances", data.data);
      }
    });
  },
  resetPreRegistrationState({ commit }) {
    commit("resetState");
  },

  setHasFilledForm({ commit }, payload) {
    commit("setHasFilledForm", payload);
  },

  setVisitApproved({ commit }, payload) {
    commit("setVisitApproved", payload);
  },

  setVisitRejected({ commit }, payload) {
    commit("setVisitRejected", payload);
  },

  setApproveVisit({ commit }, payload) {
    commit("setApproveVisit", payload);
  },

  setRejectVisit({ commit }, payload) {
    commit("setRejectVisit", payload);
  },

  async selectDifferentUserType({ commit }, payload) {
    await commit("setDifferentUserType", payload);
  },

  setSubmitted({ commit }, payload) {
    commit("setSubmitted", payload);
  },

  selectNotAllowedToRegister({ commit }, payload) {
    commit("setNotAllowedToRegister", payload);
  },

  selectVisitExists({ commit }, payload) {
    commit("setVisitExists", payload);
  },

  async selectHasVisitedPage({ commit }, payload) {
    await commit("setHasVisitedPage", payload);
  },

  setSwitch({ commit }, payload) {
    commit("setSwitch", payload);
  },

  setCommingFromLogin({ commit }, payload) {
    commit("setFromLogin", payload);
  },

  checkDuplicatedForConfirmCloud({ commit }, params) {
    return new Promise((resolve, reject) => {
      PreRegistration
        .checkDuplicated(params)
        .then((data) => {
          resolve(data);
          // console.log("store", data.data.data);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            Object.values(err.response.data.errors).join("\r\n")
          );
          commit("setRedirectLoader", false);
        });
    });
  },

  async confirmExpectedVisit({ state, commit }) {
    commit("setApiErr", null);
    commit("setIsLoading", true);
    let formData = new FormData();
    const params = {
      first_name: state.firstName,
      last_name: state.lastName,
      email: state.email ? state.email : "",
      phone: state.phone ? state.phone : "",
      company_name: state.companyName ? state.companyName : "",
      image: store.getters["userType/getPreRegistrationData"].user.image ? "" : (state.compliance.is_image_required ? state.image : ""),
    }

    if (state.registerPassportAcc) formData.append("user[passport_id]", state.user.encId);

    let customFields = [];
    if (state.sectionsData && state.sectionsData.length) {
      customFields = getCustomFieldsPayload(state.sectionsData);
    }
    formData.append("custom_fields", customFields.length ? JSON.stringify(customFields) : "");
    
    formData.append("user[first_name]", params.first_name);
    formData.append("user[last_name]", params.last_name);
    formData.append("user[email]", params.email);
    formData.append("user[phone]", params.phone);
    formData.append("user[image]", params.image);
    formData.append("user[company_name]", params.company_name);
    formData.append("user_id", store.getters["userType/getPreRegistrationData"].user.user_id);
    // formData.append("server_url", store.getters["userType/getPreRegistrationData"].serverUrl);
    formData.append("visit_id", store.getters["userType/getPreRegistrationData"].visitId);
    formData.append("is_compliance_required", Number(state.compliance.is_compliance_required));
    formData.append("is_face_id_included", Number(state.compliance.is_face_id_included));
    formData.append("is_rfid_included", Number(state.compliance.is_rfid_included));
    formData.append("is_qr_included", Number(state.compliance.is_qr_included));
    formData.append("is_using_kiosk_screen", Number(state.compliance.is_using_kiosk_screen));
    // formData.append("image_mandatory", Number(state.compliance.is_image_required));
    formData.append("registration_method", state.selectedUserType[0].pre_registration_method);
    formData.append("_method", "PUT");
    return new Promise((resolve, reject) => {
      PreRegistration.confirmExpectedVisit(formData)
        .then((response) => {
          resolve(response);
          commit("setIsLoading", false);
          if (response.data.data && response.data.data.local_qr) {
            commit("setLocalQrCodeUrl", response.data.data.local_qr);
          } else {
            commit("setLocalQrCodeUrl", null);
          }

          if (router.currentRoute.query.hasPassport && state.compliance.is_qr_included) {
            commit("setQrUrl", decodeURIComponent(router.currentRoute.query.passport_qr));
          } else {
            commit("setQrUrl", null);
          }
          // commit("setRedirectLoader", false);
          commit("setSubmitted", true);
          router.push({
            path: router.currentRoute.path + "/success",
            query: { add_visitor: true },
          });
          commit("setDifferentUserType", null);
        }).catch((err) => {
          reject(err);
          // console.log("err", err);
          commit("setRedirectLoader", false);
          commit("setApiErr", true);
          commit("setIsLoading", false);
          this._vm.$toast.error(err.data.data);
        });
    });
  },

  async confirmExpectedVisitPassport({ state, commit }) {
    commit("setApiErr", null);
    commit("setFirstName", router.currentRoute.query.first_name);
    commit("setLastName", router.currentRoute.query.last_name);
    commit("setIsLoading", true);
    let formData = new FormData();
    const params = {
      image: store.getters["userType/getPreRegistrationData"].user.image ? store.getters["userType/getPreRegistrationData"].user.image : (state.compliance.is_image_required ? state.image : ""),
    }

    let customFields = [];
    if (state.sectionsData && state.sectionsData.length) {
      customFields = getCustomFieldsPayload(state.sectionsData);
    }
    formData.append("custom_fields", customFields.length ? JSON.stringify(customFields) : "");

    formData.append("image", params.image);
    formData.append("user_id", store.getters["userType/getPreRegistrationData"].user.passport_id ? store.getters["userType/getPreRegistrationData"].user.passport_id : router.currentRoute.query.passport_id);
    formData.append("server_url", store.getters["userType/getPreRegistrationData"].serverUrl);
    formData.append("visit_id", store.getters["userType/getPreRegistrationData"].visitId);
    formData.append("is_compliance_required", Number(state.compliance.is_compliance_required));
    formData.append("is_face_id_included", Number(state.compliance.is_face_id_included));
    formData.append("is_rfid_included", Number(state.compliance.is_rfid_included));
    formData.append("is_qr_included", Number(state.compliance.is_qr_included));
    formData.append("is_using_kiosk_screen", Number(state.compliance.is_using_kiosk_screen));
    // formData.append("image_mandatory", Number(state.compliance.is_image_required));
    formData.append("registration_method", state.selectedUserType[0].pre_registration_method);
    formData.append("_method", "PUT");
    return new Promise((resolve, reject) => {
      PreRegistration.confirmExpectedVisitPassport(formData)
        .then((response) => {
          resolve(response);
          commit("setIsLoading", false);
          // console.log('successsssssssssss', router.currentRoute);
          if (router.currentRoute.query.comingFromPassport && state.compliance.is_qr_included) {
            commit("setQrUrl", decodeURIComponent(router.currentRoute.query.passport_qr));
          } else {
            commit("setQrUrl", null);
          }
          // commit("setRedirectLoader", false);
          commit("setSubmitted", true);
          router.push({
            path: router.currentRoute.path + "/success",
            query: { add_visitor: true, comingFromPassport: true },
          });
          commit("setDifferentUserType", null);
        }).catch((err) => {
          reject(err);
          console.log("err", err);
          commit("setRedirectLoader", false);
          commit("setApiErr", true);
          commit("setIsLoading", false);
          this._vm.$toast.error(err.data.data);
        });
    });
  },

  async createExpectedVisit({ state, commit }, payload) {
    console.log('createExpectedVisit', state, payload);
    commit("setRegisterPassportAcc", payload.registerPassportAcc);
    commit("setIsLoading", true);
    commit("setApiErr", null);
    let visit_date_formatted = null;
    let visit_time_formatted = null;
    let formData = new FormData();
    let params = '';
    // let user = '';
    let preReg = '';
    if (payload.data.comingFromPassport) {
      // user = JSON.parse(payload.data.user);
      preReg = JSON.parse(payload.data.preRegData);
    }

    if (state.visitDate) {
      visit_date_formatted = moment(new Date(state.visitDate)).format("YYYY-MM-DD");
    } else if (preReg && preReg.visit_date) {
      visit_date_formatted = preReg.visit_date;
    }

    if (state.visitTime) {
      visit_time_formatted = moment(state.visitTime).format("HH:mm:ss");
    } else if (preReg && preReg.visit_time) {
      visit_time_formatted = moment(preReg.visit_time, ["h:mm A"]).format("HH:mm:ss");
    }

    if (payload.data.comingFromPassport) {
      params = {
        passport_id: decodeURIComponent(payload.data.encId) || null,
        is_qr_included: Number(state.compliance.is_qr_included),
        image_mandatory: Number(state.compliance.is_image_required),
        user_type_id: preReg.user_type_id || '',
        registration_method: preReg.registration_method,
        entity_id: preReg.entity_id,
        area_id: preReg.area_id || '',
        visit_date: visit_date_formatted || '',
        visit_time: visit_time_formatted || '',
        first_name: decodeURIComponent(payload.data.first_name),
        last_name: decodeURIComponent(payload.data.last_name),
        email: payload.data.email ? decodeURIComponent(payload.data.email).replace(" ", "+") : null,
        phone: payload.data.phone ? decodeURIComponent(payload.data.phone) : null,
        passport_qr: payload.data.passport_qr ? decodeURIComponent(payload.data.passport_qr) : null,
        image: payload.data.image ? decodeURIComponent(payload.data.image) : state.image,
        company_name: payload.data.company_name ? decodeURIComponent(payload.data.company_name) : null,
        is_compliance_required: Number(state.compliance.is_compliance_required),
        is_face_id_included: Number(state.compliance.is_face_id_included),
        is_rfid_included: Number(state.compliance.is_rfid_included),
        is_using_kiosk_screen: state.compliance.is_using_kiosk_screen,
      }
    } else {
      params = {
        passport_id: null,
        is_qr_included: Number(state.compliance.is_qr_included),
        image_mandatory: Number(state.compliance.is_image_required),
        user_type_id: state.selectedUserType[0].id,
        registration_method: state.selectedUserType[0].pre_registration_method,
        entity_id: state.selectedUserType[0].entity_id,
        area_id: state.area.id,
        visit_date: visit_date_formatted,
        visit_time: visit_time_formatted,
        first_name: state.firstName,
        last_name: state.lastName,
        email: state.email,
        phone: state.phone,
        image: state.image,
        company_name: state.companyName,
        is_compliance_required: Number(state.compliance.is_compliance_required),
        is_face_id_included: Number(state.compliance.is_face_id_included),
        is_rfid_included: Number(state.compliance.is_rfid_included),
        is_using_kiosk_screen: state.compliance.is_using_kiosk_screen,
      };
      if (payload.registerPassportAcc) {
        params.passport_id_updated = state.user ? state.user.encId : null;
      }
    }

    let customFields = [];
    if (state.sectionsData && state.sectionsData.length) {
      customFields = getCustomFieldsPayload(state.sectionsData);
    }
    formData.append("custom_fields", customFields.length ? JSON.stringify(customFields) : "");

    if (params.passport_id_updated)
      formData.append("passport_id_updated", params.passport_id_updated);
    formData.append("passport_id", params.passport_id ? params.passport_id : '');
    formData.append("user_type_id", params.user_type_id);
    formData.append("registration_method", params.registration_method);
    formData.append("entity_id", params.entity_id);
    formData.append("area_id", params.area_id);
    formData.append("visit_date", params.visit_date ? params.visit_date : '');
    formData.append("visit_time", params.visit_time ? params.visit_time : '');
    formData.append("first_name", params.first_name);
    formData.append("last_name", params.last_name);
    formData.append("email", params.email ? params.email : '');
    formData.append("phone", params.phone ? params.phone : '');
    formData.append("image", params.image ? params.image : '');
    formData.append("company_name", params.company_name ? params.company_name : '');
    formData.append("image_mandatory", params.image_mandatory);
    formData.append("is_qr_included", params.is_qr_included);
    formData.append("is_compliance_required", params.is_compliance_required);
    formData.append("is_face_id_included", params.is_face_id_included);
    formData.append("is_rfid_included", params.is_rfid_included);
    formData.append("is_using_kiosk_screen", params.is_using_kiosk_screen ? 1 : 0);
    formData.append("enable_switch_usertype", state.isSwitch ? 1 : 0);
    formData.append("journey_id", store.getters["userType/getJourneyId"]);
    formData.append("host", state.selectedHost ? state.selectedHost : "");

    return new Promise((resolve, reject) => {
      PreRegistration.createExpectedVisit(formData)
        .then((response) => {
          resolve(response);
          commit("setIsLoading", false);
          if (response.data.data && response.data.data.local_qr) {
            commit("setLocalQrCodeUrl", response.data.data.local_qr);
          } else {
            commit("setLocalQrCodeUrl", null);
          }

          if (payload.data.comingFromPassport && state.compliance.is_qr_included) {
            commit("setQrUrl", decodeURIComponent(payload.data.passport_qr));
          } else {
            commit("setQrUrl", null);
          }
          // commit("setRedirectLoader", false);
          commit("setSubmitted", true);
          router.push(router.currentRoute.path + "/success");
          commit("setDifferentUserType", null);
        }).catch((err) => {
          reject(err);
          // console.log("err", err);
          commit("setRedirectLoader", false);
          commit("setApiErr", true);
          commit("setIsLoading", false);
          this._vm.$toast.error(err.data.data);
        });
    });
  },

  editExpectedVisit({ commit }, payload) {
    commit("setRefreshGrid", false);
    return new Promise((resolve, reject) => {
      PreRegistration.editExpectedVisit(payload)
        .then((response) => {
          resolve(response);
          console.log('editExpectedVisit', response);
          commit("setRefreshGrid", true);
        }).catch((err) => {
          reject(err);
          // console.log("err", err);
          commit("setApiErr", true);
          this._vm.$toast.error(err.data.data);
        });
    });
  },

  deleteExpectedVisit({ commit }, payload) {
    commit("setRefreshGrid", false);
    return new Promise((resolve, reject) => {
      PreRegistration.deleteExpectedVisit(payload)
        .then((response) => {
          resolve(response);
          console.log('deleteExpectedVisit', response);
          commit("setRefreshGrid", true);
        }).catch((err) => {
          reject(err);
          // console.log("err", err);
          commit("setApiErr", true);
          this._vm.$toast.error(err.data.data);
        });
    });
  },

  getValidateUserType({ commit }, payload) {
    PreRegistration.validateUserType(payload).then(async (response) => {
      console.log('getValidateUserType', response);
      if (response.data.data.user_exists) {
        commit("setUserTypeName", response.data.data.user_type.name);
        await commit("setNotAllowedToRegister", !response.data.data.can_change_user_type);
      } else await commit("setNotAllowedToRegister", false);
    }).catch(() => {
      // console.log("getValidateUserType err", err);
    });
  },

  checkUserEntity({ state, commit }, payload) {
    PreRegistration.checkUserEntity(payload).then(async (response) => {
      console.log('checkUserEntity', state.selectedUserType[0].id, response.data.data.user_type_id);
      if (response.data.data && response.data.data.length == 0) {
        commit("setDifferentUserType", false);
        commit("setUserEntity", null);
      } else if (state.selectedUserType[0].id !== response.data.data.user_type_id) {
        await commit("setDifferentUserType", true);
        commit("setUserEntity", response.data.data);
      } else {
        commit("setDifferentUserType", false);
        commit("setUserEntity", response.data.data);
      }
    }).catch(() => {
      commit("setDifferentUserType", false);
      // console.log("checkUserEntity err", err);
    });
  },

  checkVisitExists({ state, commit }, payload) {
    console.log('checkVisitExists', payload);
    commit("setNotAllowedToRegister", false);

    let visit_date_formatted = null;
    let visit_time_formatted = null;
    let preReg = payload.data.comingFromPassport ? JSON.parse(payload.data.preRegData) : '';

    if (state.visitDate) {
      visit_date_formatted = moment(new Date(state.visitDate)).format("YYYY-MM-DD");
    } else if (preReg && preReg.visit_date) {
      visit_date_formatted = preReg.visit_date;
    }

    if (state.visitTime) {
      visit_time_formatted = moment(state.visitTime).format("HH:mm:ss");
    } else if (preReg && preReg.visit_time) {
      visit_time_formatted = moment(preReg.visit_time, ["h:mm A"]).format("HH:mm:ss");
    }

    const obj = {
      passport_id: payload.data.comingFromPassport ? decodeURIComponent(payload.data.encId) || null : (state.registerPassportAcc ? (state.user ? state.user.encId : '') : ''),
      email: payload.data.comingFromPassport ? (payload.data.email ? decodeURIComponent(payload.data.email) : '') : (state.email ? state.email : ''),
      phone: payload.data.comingFromPassport ? (payload.data.phone ? decodeURIComponent(payload.data.phone) : '') : (state.phone ? state.phone : ''),
      entity_id: payload.data.comingFromPassport ? preReg.entity_id : state.selectedUserType[0].entity_id,
      area_id: payload.data.comingFromPassport ? preReg.area_id || '' : state.area.id,
      visit_date: visit_date_formatted,
      visit_time: visit_time_formatted,
    }

    // if (state.registerPassportAcc) {
    //   obj.passport_id_updated = state.user ? state.user.encId : null;
    // }
    PreRegistration.checkVisitExists(obj).then(async (response) => {
      console.log('checkVisitExists', response);
      if (response.data.data) {
        commit("setVisitExists", false);
        commit("setMsgTitle", null);
        commit("setMsgBody", null);
      }
    }).catch((err) => {
      if (err.data.message == "error_date") {
        console.log('date_error');
        commit("setVisitExists", true);
        commit("setMsgTitle", err.data.data.Title);
        commit("setMsgBody", err.data.data.message);
      }
      console.log("checkVisitExists err", err);
    });
  },

  approveVisit({ commit }, payload) {
    commit('setVisitApproved', false);
    return new Promise((resolve, reject) => {
      PreRegistration.approveVisit(payload)
        .then((data) => {
          resolve(data);
          console.log('approveVisit', data);
          commit('setVisitApproved', true);
        }).catch((err) => {
          reject(err);
          // console.log("checkUserEntity err", err);
        });
    });
  },

  rejectVisit({ commit }, payload) {
    commit('setVisitRejected', false);
    return new Promise((resolve, reject) => {
      PreRegistration.rejectVisit(payload)
        .then((data) => {
          resolve(data);
          console.log('rejectVisit', data);
          commit('setVisitRejected', true);
        }).catch((err) => {
          reject(err);
          // console.log("checkUserEntity err", err);
        });
    });
  },

  approveRejectedVisit({ commit }, payload) {
    commit('setVisitApproved', false);
    return new Promise((resolve, reject) => {
      PreRegistration.approveRejectedVisit(payload)
        .then((data) => {
          resolve(data);
          console.log('approveRejectedVisit', data);
          commit('setVisitApproved', true);
        }).catch((err) => {
          reject(err);
          // console.log("checkUserEntity err", err);
        });
    });
  },

  rejectApprovedVisit({ commit }, payload) {
    commit('setVisitRejected', false);
    return new Promise((resolve, reject) => {
      PreRegistration.rejectApprovedVisit(payload)
        .then((data) => {
          resolve(data);
          console.log('rejectApprovedVisit', data);
          commit('setVisitRejected', true);
        }).catch((err) => {
          reject(err);
          // console.log("checkUserEntity err", err);
        });
    });
  },

  getPreRegDetails({ commit }, payload) {
    // commit('setVisitRejected', false);
    return new Promise((resolve, reject) => {
      PreRegistration.getPreRegDetails(payload.visitUrl)
        .then((data) => {
          resolve(data);
          // console.log('getPreRegDetails', data);
          commit("userType/setPreRegistrationTypes", data.data.data, { root: true });
          if (data.data.data.visitMetadata.is_expired && JSON.parse(data.data.data.visitMetadata.is_expired)) {
            let msg = "Your confirmation link has expired because ";
            if (data.data.data.visitMetadata.reason == "VISIT_REJECTED") msg += "your visit has not been approved. ";
            else if (data.data.data.visitMetadata.reason == "VISIT_DELETED") msg += "your visit has been deleted. ";
            else if (data.data.data.visitMetadata.reason == "VISIT_EXPIRED" || data.data.data.visitMetadata.reason == "SCAN_EXPIRED") msg += "you missed your appointment. ";
            else msg += "you have already arrived at the area. ";
            msg += "Please contact the system admin for further details."
            commit("setExpiryMsg", msg);
            router.push("/link-expired");
            return;
          } else if (!payload.onlineComp && data.data.data.visitMetadata.is_confirmed && JSON.parse(data.data.data.visitMetadata.is_confirmed)) {
            let msg = "Your confirmation link has expired because you have already confirmed your visit. Please contact the system admin for further details."
            commit("setExpiryMsg", msg);
            router.push("/link-expired");
          }
          commit('setCompliances', data.data.data.validations);
          commit("setExpectedDateTime", new Date(data.data.data.expectedDateTime));
          // commit("setVisitTime", new Date(data.data.data.expectedDateTime));
          commit("setFirstName", data.data.data.user.first_name);
          commit("setLastName", data.data.data.user.last_name);
          commit("setEmail", data.data.data.user.email);
          commit("setPhoneInput", data.data.data.user.phone);
          commit("setPhone", data.data.data.user.phone);
          commit("setCompanyName", data.data.data.user.company_name);
        }).catch((err) => {
          reject(err);
          console.log("err", err);
          commit("setExpiryMsg", "Err");
          let link = "/link-expired";
          router.push(link);
        });
    });
  },

  selectUserType({ commit }, params) {
    commit("setSelectedUserType", params);
  },
  selectVisitDate({ commit }, params) {
    commit("setVisitDate", params);
  },
  selectVisitTime({ commit }, params) {
    commit("setVisitTime", params);
  },
  selectFirstName({ commit }, params) {
    commit("setFirstName", params);
  },
  selectLastName({ commit }, params) {
    commit("setLastName", params);
  },
  selectCompanyName({ commit }, params) {
    commit("setCompanyName", params);
  },
  selectUserEntity({ commit }, params) {
    commit("setUserEntity", params);
  },

  selectEmail({ commit }, params) {
    commit("setEmail", params);
  },
  selectPhone({ commit }, params) {
    commit("setPhone", params);
  },
  selectPhoneInput({ commit }, params) {
    commit("setPhoneInput", params);
  },
  selectUserCountryCode({ commit }, params) {
    commit("setUserCountryCode", params);
  },
  selectRegistrationCheck({ commit }, params) {
    commit("setRegistrationCheck", params);
  },
  selectRedirectLoader({ commit }, params) {
    console.log('setloaderrr', params);
    commit("setRedirectLoader", params);
  },

  setSelectedHost({ commit }, params) {
    commit("setSelectedHost", params);
  },
};

export const getters = {
  getUser(state) {
    return state.user;
  },
  getSelectedEntity(state) {
    return state.entity;
  },
  getSelectedArea(state) {
    return state.area;
  },
  getRegisteredUser(state) {
    return state.user;
  },
  getCompliance(state) {
    return state.compliance;
  },
  getSelectedUserType(state) {
    return state.selectedUserType;
  },
  getJourneyFlowId(state) {
    return state.selectedUserType?.[0]?.journey_flow_id;
  },
  getVisitDate(state) {
    return state.visitDate;
  },
  getVisitTime(state) {
    return state.visitTime;
  },
  getExpectedDateTime(state) {
    return state.expectedDateTime;
  },
  getFirstName(state) {
    return state.firstName;
  },
  getLastName(state) {
    return state.lastName;
  },
  getEmail(state) {
    return state.email;
  },
  getPhone(state) {
    return state.phone;
  },
  getCompanyName(state) {
    return state.companyName;
  },
  getPhoneInput(state) {
    return state.phoneInput;
  },
  getUserCountryCode(state) {
    return state.userCountryCode;
  },

  getRegisterPassportAcc(state) {
    return state.registerPassportAcc;
  },

  getLocalQrCodeUrl(state) {
    return state.localQrCodeUrl;
  },

  getHasFilledForm(state) {
    return state.hasFilledForm;
  },

  getUserEntity(state) {
    return state.userEntity;
  },

  getDifferentUserType(state) {
    return state.differentUserType;
  },

  getSubmitted(state) {
    return state.isSubmitted;
  },

  getUserTypeName(state) {
    return state.userTypeName;
  },

  getNotAllowedToRegister(state) {
    return state.notAllowedToRegister;
  },

  getVisitExists(state) {
    return state.visitExists;
  },

  getMsgTitle(state) {
    return state.msgTitle;
  },

  getMsgBody(state) {
    return state.msgBody;
  },

  getHasVisitedPage(state) {
    return state.hasVisitedPage;
  },

  getSwitch(state) {
    return state.isSwitch;
  },

  getFromLogin(state) {
    return state.fromLogin;
  },

  getQrCodeUrl(state) {
    return state.qrUrl;
  },

  getRedirectLoader(state) {
    return state.redirectLoader;
  },

  getIsLoading(state) {
    return state.isLoading;
  },

  getDaysDiff(state) {
    return state.daysDiff;
  },

  getOffset(state) {
    return state.offset;
  },

  getVisitApproved(state) {
    return state.visitApproved;
  },

  getVisitRejected(state) {
    return state.visitRejected;
  },

  getApproveVisit(state) {
    return state.approveVisit;
  },

  getRejectVisit(state) {
    return state.rejectVisit;
  },

  getApiErr(state) {
    return state.apiErr;
  },

  getRefreshGrid(state) {
    return state.refreshGrid;
  },

  getSelectedHost(state) {
    return state.selectedHost;
  },

  getExpiryMsg(state) {
    return state.expiryMsg;
  },
  getSections(state){
    return state.sectionsData
  }
};
